import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const createUserAccount: DocumentNode = gql`
  mutation CreateUser($email: EmailAddress!, $password: String!, $productName: OutputLoginProductName = Website) {
    createUser(productName: $productName, input: { email: $email, password: $password }) {
      ... on CreateUserResponse {
        apiKey
        refreshToken
      }
      ... on CreateUserError {
        code
        message
      }
    }
  }
`

export default createUserAccount
